module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n\t" + _vm._s(_vm.klass.description) + "\n\t"), _c('small', [_vm._v(_vm._s(_vm._f("date")(_vm.agendaDate, 'DD/MM/YYYY')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282feb58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/school/class-name/main.vue
// module id = 1049
// module chunks = 1